/**
 * casestudy
 */
'use strict';
import AppCaseEntry from '@/_modules/app_case_entry';

document.addEventListener('DOMContentLoaded', () => {
  new AppCaseEntry();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
